// Tiny helper to request resized/WebP variants of images served by /api/uploads/files/...
// Falls back to the original URL for external images (e.g. http(s)://example.com/...).
// Backend caches transformed variants on disk, so subsequent requests are very fast.

export function imgVariant(src, { w, fmt = 'webp', q = 82 } = {}) {
  if (!src || typeof src !== 'string') return src;
  // Only optimize our own upload URLs (path-only or absolute matching backend host)
  const isUploads = src.includes('/api/uploads/files/');
  if (!isUploads) return src;
  // Append query params (preserve existing query if any)
  const hasQuery = src.includes('?');
  const params = [];
  if (w) params.push(`w=${w}`);
  if (fmt) params.push(`fmt=${fmt}`);
  if (q) params.push(`q=${q}`);
  if (params.length === 0) return src;
  return `${src}${hasQuery ? '&' : '?'}${params.join('&')}`;
}

// Build a `srcSet` for retina/mobile crispness without overpaying bandwidth.
export function imgSrcSet(src, widths = [200, 400, 600], fmt = 'webp') {
  if (!src || !src.includes('/api/uploads/files/')) return undefined;
  return widths.map((w) => `${imgVariant(src, { w, fmt })} ${w}w`).join(', ');
}
